// removed by extract-text-webpack-plugin
module.exports = {"root":"_3X93KCBwLqmxcmQ57MC0Dl","head":"_1s43j8uvZi7l36dpFxUUkQ","content":"_13ipwIvUPgA4D4jr0X9_tz","primaryCta":"_39WkML1p72PTaftPggU09h"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/EndorseContentLayout/styles.scss
// module id = ./node_modules/wix-style-react/dist/es/src/EndorseContentLayout/styles.scss
// module chunks = 0